import React from 'react';
import { Modal } from 'antd';
import './DefaultModal.scss';
import { ReactComponent as Close } from '../../../../../resources/images/svg/close.svg';

function DefaultModal({
  show, setShow, children, width, centered, className, zIndex,
}) {
  const props = {};

  if (zIndex) {
    props.zIndex = { zIndex };
  }

  return (
    <Modal
      open={show}
      footer={null}
      closeIcon={<Close />}
      onCancel={() => setShow(false)}
      className={`default-modal ${className}`}
      maskStyle={{
        backdropFilter: 'blur(30px)',
      }}
      width={width}
      centered={centered}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
    >
      {children}
    </Modal>
  );
}

export default DefaultModal;
